import * as React from 'react';
import { cn } from '@/shared/lib/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'field-glass flex h-10 w-full rounded-lg border border-input bg-[hsl(var(--glass-bg)/0.5)] px-3.5 py-2 shadow-glass-sm backdrop-blur-sm transition-[box-shadow,border-color,background-color] duration-200',
        'placeholder:text-muted-foreground/70',
        'focus-visible:border-primary/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className,
        /* 16px no mobile evita zoom automático do iOS ao focar o campo. */
        'text-[16px] sm:text-sm',
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
